import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src1140675788/src/primary-ai-website/node_modules/.pnpm/next@15.5.21_@babel+core@7.29.7_@types+node@22.20.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/node_modules/.pnpm/next@15.5.21_@babel+core@7.29.7_@types+node@22.20.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/blog/category/artificial-intelligence.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/blog/category/financial-impact.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/blog/category/must-read.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/blog/category/remote-work.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/blog/category/security-news.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/blog/category/threat-landscape.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/chevron-right.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/public/assets/icons/partnership.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/controlPlane.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/dxc.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/primaryLogotypeWhite.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/arrows.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/badge-square.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/core-ring.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/globe.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-devices.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-fact-check.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-lock.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-nearby-error.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-person.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-pest-control.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-secure-gateway.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/assets/ucp/icon-shield.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/LatestPostBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/home/StaticHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/Layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1140675788/src/primary-ai-website/src/components/Nav/NavigationBar.tsx");
